import { AxiosResponse } from 'axios'
import { axiosInstance } from '~/src/config/config_axios'
import { IListOfFreightResponse } from '~/src/repositories/freight_repository/models/freight'

export class FreightRepository {
  async getFreight(): Promise<AxiosResponse<IListOfFreightResponse['data']>> {
    return axiosInstance.get('/freight')
  }

  async editFreight(id?: string): Promise<void> {
    return axiosInstance.patch(`/freight/${id}`)
  }
}
